<template>
  <div
    v-if="comment.user.id === user.id && comment.company.id === company.id"
    class="card"
  >
    <div
      v-if="request.requestType === 'RFQ'"
      class="card-body"
    >
      <h4>{{ $t('myLogOffer.mnimTklifim') }}</h4>
      <hr>
      <div
        v-for="(p,i) in getRFQPrices(comment.commentData)"
        :key="i"
      >
        <div
          v-if="!p.alterantive"
          class="row"
        >
          <div class="col-6">
            <strong>
              {{ p.product.name }}
            </strong>
            <br>
            <span> {{ p.product.count }} {{ p.product.unit }} </span>
          </div>
          <div class="col-6 text-right">
            <span v-if="p.price">
              <strong>{{ $t('myRfqOffer.1PproductunitNQiymt', {unit:p.product.unit}) }}</strong> <br>
              {{ $t('offerExtrasView.azn', {price: p.price}) }}
            </span> <br>
            <span v-if="p.totalPrice">
              <strong>{{ $t('myRfqOffer.pproductcountPproductunitNQiymt') }}</strong> <br>
              {{ $t('myPQTOffer.azn', {totalPrice: p.totalPrice}) }}
            </span> <br>
            <span>{{ getIsTaxIncluded(p.taxIncluded) }}</span>
          </div>
        </div>
        <div
          v-else
          class="row text-danger"
        >
          <div class="col-12">
            <strong>{{ $t('myRfqOffer.alternativMhsul') }}</strong>
          </div>
          <div class="col-6">
            <strong>
              {{ p.alternative.name }}
            </strong>
            <br>
            <span>
              {{ $t('myRfqOffer.sbbPalternativereason', {reason:p.alternative.reason}) }}
            </span>
          </div>
          <div class="col-6 text-right">
            <strong>
              {{ $t('myRfqOffer.palternativepriceAzn', {price:p.alternative.price}) }}
            </strong>
            <br>
            <span>
              {{ getIsTaxIncluded(p.taxIncluded) }}
            </span>
          </div>
        </div>
      </div>

      <em class="text-secondary">
        {{ getMoment(comment.logTime) }}
      </em>

      <div
        v-if="conversation"
        class="mt-3"
      >
        <router-link
          class="btn btn-primary"
          :to="`/dashboard/conversation/${conversation.id}`"
        >
          <span v-if="conversation.open">{{ $t('commentView.mzakiryDavamEt') }}</span>
          <span v-else>{{ $t('commentView.mzakiryBax') }}</span>
        </router-link>
      </div>
    </div>

    <div
      v-if="request.requestType === 'LOG'"
      class="card-body"
    >
      <h4>{{ $t('myLogOffer.mnimTklifim') }}</h4>
      <hr>
      <div
        v-for="(p,i) in getRFQPrices(comment.commentData)"
        :key="i"
      >
        <div class="row">
          <div class="col-6">
            <strong>
              {{ p.product.name }}
            </strong>
            <br>
            <span>{{ p.product.count }} {{ p.product.unit }}</span>
          </div>
          <div class="col-6 text-right">
            <span v-if="p.price">
              <strong>{{ $t('myRfqOffer.1PproductunitNQiymt', {unit:p.product.unit}) }}</strong> <br>
              {{ $t('offerExtrasView.azn', {price: p.price}) }}
            </span> <br>
            <span v-if="p.totalPrice">
              <strong>{{ $t('myRfqOffer.pproductcountPproductunitNQiymt', {count:p.product.count ,unit:p.product.unit}) }}</strong> <br>
              {{ $t('myPQTOffer.azn', {totalPrice: p.totalPrice}) }}
            </span> <br>
            <span>{{ getIsTaxIncluded(p.isTaxIncluded) }}</span>
          </div>
        </div>
      </div>


      <em class="text-secondary">
        {{ getMoment(comment.logTime) }}
      </em>

      <div
        v-if="conversation"
        class="mt-3"
      >
        <router-link
          class="btn btn-primary"
          :to="`/dashboard/conversation/${conversation.id}`"
        >
          <span v-if="conversation.open">{{ $t('commentView.mzakiryDavamEt') }}</span>
          <span v-else>{{ $t('commentView.mzakiryBax') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getIsTaxIncluded} from "@/repositories/Utils";
import moment from "moment/moment";

export default {
  name: 'MyRFQOffer',
  props: {
    comment: {},
    request: {},
    products: {},
    conversations: {}
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      company: state => state.auth.company,
    }),
    conversation(){
      let list = this.conversations.filter(conversation => this.comment.user.id === conversation.user.id && this.comment.company.id === conversation.company.id && this.comment.profileType === conversation.profileType);
      if(list.length>0){
        return list[0];
      }
      else  return  null;
    }
  },
  methods: {
    getIsTaxIncluded(value) {
      return getIsTaxIncluded(parseInt(value), this.i18n);
    },
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getProductById(id) {
      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })
      return prod;
    },

    getRFQPrices(commentData) {

      let prices = [];

      let json = JSON.parse(commentData);


      if (json.hasOwnProperty("prices")) {
        //new version

        Object.keys(json.prices).forEach((k) => {
          let alternative = null;
          if (json.hasOwnProperty("alternative") && json.alternative[k]) {
            console.log(json.alternative);
            alternative = json.alternative[k]
          }
          prices.push({
            product: this.getProductById(k),
            price: json.prices[k],
            totalPrice: json.totalPrices[k],
            taxIncluded: json['taxIncluded'][k],
            alternative: alternative
          })
        })

      } else {
        //old version

        json.forEach((v, k) => {
          prices.push({
            product: this.getProductById(k),
            price: v,
            taxIncluded: -1
          })
        })
      }

      return prices;

    },
  }
}
</script>
